$(function() {
	$('.template-index .jdgm-all-reviews-page__load-more').on('click', function(){
		window.location.href = '/pages/reviews';
	});

	$('.best-seller-carousel').each(function(){
		$(this).slick({
			variableWidth: true,
			arrows: true
		});
		$(this).find('.best-seller-carousel-button').on('click', function(e){
			e.preventDefault();
			e.stopPropagation();

			$.ajax({
        url: '/cart/add.js',
        method: 'POST',
        data: {
        	quantity: 1,
        	id: $(this).attr('data-id')
      	},
        success: function() {
        	CartJS.getCart();
        }
      });
		})
	});

	$(document).on('click', '#menu_btn', function(){
		$(this).toggleClass('active');
		$('body').toggleClass('stick');
		$('.mobile_menu').toggleClass('active');
	});

	$(document).on('click', '.j-cart', function(e){

		e.preventDefault();
		$('.mini-cart').toggleClass('active');


	});

	$(document).on('click', '.mini-cart .j-close', function(){

		$('.mini-cart').removeClass('active');

	});

	$(document).on('cart.requestComplete', function(event,cart) {


      // Check if mini cart has box

      var hasHiddenProduct = false;

      // if ( $('.mini-cart-contents .item_wrapper').hasClass('minus_one') ){

      //   var hasHiddenProduct = true;

      // }

        // $('.mini-cart').load('/ .mini-cart-contents', function(){

        // 	$(this).addClass('active');

        // 	$('.site_header .cart .counter').text('');
        //   	var cartNo = cart.item_count;
        //     jQuery.getJSON('/cart.js', function(cart) {
				// 			$('.site_header .cart .counter').text( '(' + cartNo + ')' );
				// 	 	});
        // });

    });

    $(document).on('click', '.accordian_row .trigger', function(e){

    	e.preventDefault();
    	$(this).parent().toggleClass('active').siblings().removeClass('active');

    });


	$(document).on('scroll', function(){

		// $('.offset-grid-item').each(function(){

		// 	if ($(this).visible(true)) {
		// 		$(this).addClass('animated fadeInUp');
		// 	}

		// });

		$('.colour-kit-steps .step-wrapper').each(function(){

			if ($(this).visible(true)) {
				$(this).addClass('animated fadeInUp');
			}

		});


		$('.how-it-works .usp-list .usp-wrap').each(function(){

			if ($(this).visible(true)) {
				$(this).addClass('animated fadeInUp');
			}

		});


		if ($('.home-two-column .colour-column').first().visible(true)) {

			$('.home-two-column .colour-column').first().addClass('animated fadeInLeft');

		}

		if ($('.home-two-column .colour-column').last().visible(true)) {

			$('.home-two-column .colour-column').last().addClass('animated fadeInRight');

		}


	});


	$(document).on('click', '.product_item .add_to_cart', function(e){

		e.preventDefault();

		var id 			= $(this).data('variantid');
		var quantity 	= $(this).closest('.product_item').find(".quantity_update").val();

		CartJS.addItem(id, quantity, {}, {
        "success": function(data, textStatus, jqXHR) {
          window.__CART_INSTANCE__.toggleMiniCart()
        },
		    "error": function(jqXHR, textStatus, errorThrown) {

		        $('.alert_notification').addClass('active');
		        $('#alert_message').text(jqXHR.responseJSON.description);

		        setTimeout(function(){

		        	$('.alert_notification').removeClass('active');

		        }, 3000);

		    }
		});

		// Close cart after 6 seconds

		setTimeout(function(){
			$('.mini-cart').removeClass('active');
		}, 6000);
    try {
      obApi('track', 'Add to Cart')
    } catch (error) {

    }
	});


	// FadeIn fixed button on mobile

	if ($(window).width() < 870) {

	   $(window).scroll(function() {
		    if ($(window).scrollTop() > 100) {
		        $('.fixed_btn').fadeIn();
		    }
		    else {
		        $('.fixed_btn').fadeOut();
		    }
		})

	}


	$(document).on('click', '.account_navigation a', function(e){

		if ( !$(this).hasClass('disabled') ){

			e.preventDefault();
			$('.account-section').hide(); // Hide all on click
			$('.account_navigation a').removeClass('active');
			$(this).addClass('active');
			window.location.hash = $(e.currentTarget).attr('href').replace('#', '')

			if ( $(this).hasClass('j-account-color-file') ){

				$('#account-color-file').show();

			} else if ( $(this).hasClass('j-account-order-history') ) {

				$('#account-order-history').show();

			} else {

				$('#account-subscriptions').show();

			}

		}

	});


  var discountCodes = ['BUNTE20191', 'BUNTE20192', 'BUNTE20193', 'BUNTE20194', 'BUNTE20195'];

  if(discountCodes.indexOf($.cookie("discount_code")) > -1){
	$('.price-coupom-original, .price-coupom-discount').addClass('active');
  }

  $('.steps_section').each(function(){
		var section = $(this)
  	var items = section.find('.product_container .item')
  	var arrows = section.find('.arrow')

  	arrows.click(function(){
  		var arrow = $(this)
  		var activeItem = items.filter('.active')
  		
  		if (arrow.hasClass('arrow-left')) {
  			items.filter('[data-product=' + (activeItem.data('product') === 1 ? items.length : (activeItem.data('product') - 1)) + ']').click()
  		} else if ('arrow-right') {
  			items.filter('[data-product=' + (activeItem.data('product') === items.length ? 1 : (activeItem.data('product') + 1)) + ']').click()
  		}
  	})
  });
});
